// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/mitarbeiterfest-der-dietz-gmbh/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const mitarbeiterfestDerDietzGmbhDE: PageEntry = {
  id: "post.mitarbeiterfest-der-dietz-gmbh",
  locale: "de",
  slug: "mitarbeiterfest-der-dietz-gmbh",
  seo: {
    title: "Mitarbeiterfest der Dietz GmbH | Bier- und Bratwurstfreitag | Dietz GmbH",
    description: "Mitarbeiterfest der Dietz GmbH | Bier- und Bratwurstfreitag",
  },
  type: "post",
  h1: "Mitarbeiterfest der Dietz GmbH | Bier- und Bratwurstfreitag",
  blocks: [
    { kind: "heading", level: 2, text: "Mitarbeiterfest der Dietz GmbH | Bier- und Bratwurstfreitag" },
    { kind: "paragraph", text: "Am vergangenen Freitag waren alle Mitarbeiterinnen und Mitarbeiter zu Bratwurst und Bier eingeladen. Bei sonnigem Wetter verbrachten wir gemeinsam ein paar schöne Stunden und nutzten die Zeit zum gemeinsamen Austausch." }
  ],
};
